import React from "react";
import styled from "styled-components";

const CipsWrapper = styled.div<{
  $inverted?: boolean;
  $color?: string;
}>`
  min-width: 20px;
  background-color: ${(props) => (props.$inverted ? "none" : props.$color)};
  color: ${(props) => (props.$inverted ? props.$color : "white")};
  border: ${(props) =>
    props.$inverted ? `2px solid ${props.$color}` : "none"};
  padding: 5px 10px;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
`;

interface Props {
  text?: string;
  icon?: React.ReactNode;
  color?: string;
  inverted?: boolean;
}

const Cips: React.FC<Props> = ({
  text,
  icon,
  inverted,
  color = "var(--secondary-green)",
}) => {
  return (
    <CipsWrapper $inverted={inverted} $color={color}>
      {icon} {text}
    </CipsWrapper>
  );
};

export default Cips;
